//import { json } from "express";
import { useEffect, useState } from "react";
import settings from "../utils/settings";
import SFError from "../models/SfError";
import { useDataProvider } from "react-admin";
const useStatRevenue = (periodType, fromDate, toDate) => {
  const [statRevenue, setStatRevenue] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider(); //Lazy auth check
  useEffect(() => {
    const getTotalRevenue = async () => {
      await dataProvider.getList("merchant-branches", {});

      const { token, branchId } = settings();
      let urlBranch = "";
      if (branchId) urlBranch = `&branch_id=${branchId}`;
      try {
        const result = await fetch(
          `${process.env.REACT_APP_API_ENDPOINT}/stat/total-revenue?period_type=${periodType}&from=${fromDate}&to=${toDate}${urlBranch}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
        );

        if (!result.ok) {
          const jsonResult = await result.json();
          setError(
            new SFError({
              status: result.status,
              code: jsonResult.code,
              message: jsonResult.message,
              wgCode: jsonResult.code,
            })
          );
          return setLoading(false);
        }
        const jsonResult = await result.json();
        setStatRevenue(jsonResult);
        return setLoading(false);
      } catch (error) {
        setError(error);
        return setLoading(false);
      }
    };
    getTotalRevenue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [periodType, fromDate, toDate]);
  return { statRevenue, loading, error };
};

export default useStatRevenue;
